
import TipoEnvioEstadoCuentaModel from "@/models/TipoEnvioEstadoCuenta/TipoEnvioEstadoCuentaModel";
import UmbracoApiService from "@/services/UmbracoApiService";
import WsdlService from "@/services/WsdlService";
import GlobalConfig from "@/GlobalConfig";
import { Component, Prop, Vue } from "vue-property-decorator";
import Option from "@/models/SelectOption";
import TypeResponse from "@/models/WsdlResponses/TypeResponse";
import { AxiosResponse } from "axios";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import Swal from "sweetalert2";
import AfiliadoService from "@/services/AfiliadoService";

@Component({})
export default class TipoEnvioEstadoCuentaForm extends Vue {
	@Prop() labelData: TipoEnvioEstadoCuentaModel;
	@Prop() isProcessing: boolean;

    public umbracoService = new UmbracoApiService();
    public communicationSources: Array<Option<TypeResponse>> = [];
	public afiliadoService: AfiliadoService = new AfiliadoService();
    public agreedToTerms: boolean = false;
    public communicationSource: TypeResponse = null;
    public tiposDeFondos: Array<Option<FundType>> = [];
    public tipoFondo: FundType = new FundType();
    public wsdlService: WsdlService = new WsdlService();
    public userId: string = this.$store.state.user.cedula;

    async mounted() {
        await this.getTypes();
        await this.getDropdownData();
    }

    public getTypes() {
        this.wsdlService
            .GetGestion("")
            .then((response: AxiosResponse<Array<TypeResponse>>) => {
                this.communicationSources = response.data.map(
                    (respObj: TypeResponse) => ({
                        value: respObj,
                        text: respObj.descripcion,
                        disabled: false,
                    })
                );
                this.communicationSource = response.data[0];
            });
    }
    updateUser() {

        this.$router.push("actualizacion-de-datos");
    }
    public async check() {
        if (!this.agreedToTerms) {
            Swal.fire({
                text: 'Debe Elegir "Si Acepto" para procesar su solicitud',
                icon: "error",
                showConfirmButton: true,
                confirmButtonText: "Ok",
            });
        }
		else{
			let ip = (await this.afiliadoService.getUserIpAddress()).data.ip;
			this.$emit('process', this.communicationSource, this.tipoFondo, ip);
		}
    }
    async getDropdownData() {
        this.wsdlService
            .getTipoDeFondos(this.userId, "")
            .then((response: AxiosResponse<FundTypeObj>) => {
                let option = new Option<FundType>();
                option.value = response.data.tipofondos;
                option.text = response.data.tipofondos.valor;
                option.disabled = false;
                this.tiposDeFondos.push(option);
                this.tipoFondo = option.value;
            });
    }
    returnHome() {
        window.location.href = GlobalConfig.PORTAL_BASE_URL
    }
}
